import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import BlockIcon from '@mui/icons-material/Block';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          padding: 3
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 6,
            borderRadius: 3,
            maxWidth: 500,
            width: '100%',
            backgroundColor: '#fff',
            border: '2px solid #f0f0f0'
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                backgroundColor: '#ffebee',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '3px solid #f44336'
              }}
            >
              <BlockIcon sx={{ fontSize: 40, color: '#f44336' }} />
            </Box>

            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: '#d32f2f',
                marginBottom: 1
              }}
            >
              Access Denied
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: '#666',
                fontSize: '16px',
                lineHeight: 1.6,
                marginBottom: 3
              }}
            >
              You don't have permission to access this page. Please contact your administrator if you believe this is an error.
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
              <Button
                component={Link}
                to="/"
                variant="contained"
                startIcon={<ArrowBackIcon />}
                sx={{
                  backgroundColor: '#bb1ccc',
                  '&:hover': {
                    backgroundColor: '#000080'
                  },
                  padding: '10px 24px',
                  borderRadius: '8px'
                }}
              >
                Go to Home
              </Button>
              
              <Button
                variant="outlined"
                onClick={() => navigate(-1)}
                sx={{
                  borderColor: '#bb1ccc',
                  color: '#bb1ccc',
                  '&:hover': {
                    borderColor: '#000080',
                    backgroundColor: '#f0f8ff'
                  },
                  padding: '10px 24px',
                  borderRadius: '8px'
                }}
              >
                Go Back
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied; 